export default __webpack_public_path__ + "static/media/team3.17d0c031.png";